import { PhoneInput, getPhoneData } from "../ui/phonInput";
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import * as z from "zod";
import CustomButton from "../CustomButton";
import { useToast } from "@/components/hooks/use-toast";
import { phoneSchema, phoneSchema2 } from "@/lib/utils";
import { useWizard } from "react-use-wizard";
import { useMutation } from "@tanstack/react-query";
import { resendOtpApiCall } from "@/api/apiFunction";

interface OTPVerificationProps {
  setMobileNumber: (number: string) => void;
  mobileNo: string;
}

const OTPVerification: React.FC<OTPVerificationProps> = ({
  setMobileNumber,
  mobileNo,
}) => {
  const { nextStep } = useWizard();

  const { toast } = useToast();
  const form = useForm<z.infer<typeof phoneSchema>>({
    mode: "onBlur",
    resolver: zodResolver(phoneSchema2),
    defaultValues: {
      phone: "",
    },
  });

  const { mutate } = useMutation({
    mutationFn: resendOtpApiCall,
    onSuccess: () => {
      toast({
        variant: "default",
        title: "OTP sent to your mobile number",
      });
      nextStep();
    },
    onError: (error: any) => {
      toast({
        title: "OTP sending Failed!",
        description: `${error?.response?.data?.message || "An error occurred"}`,
        variant: "destructive",
      });
    },
  });

  function onSubmit(data: z.infer<typeof phoneSchema2>) {
    const phoneData = getPhoneData(data.phone);
    // console.log("phoneData", phoneData);
    if (!phoneData.isValid) {
      form.setError("phone", {
        type: "manual",
        message: "Invalid phone number",
      });
      return;
    }

    // console.log(phoneData);
    const formData = {
      mobile: phoneData.nationalNumber
        ? phoneData.nationalNumber.toString()
        : "",
      phoneCode: `+${phoneData.countryCallingCode}`,
      reson: "USER_VERIFICATION",
    };
    setMobileNumber(
      phoneData.nationalNumber ? phoneData.nationalNumber.toString() : ""
    );

    if (mobileNo == formData.mobile) {
      return toast({
        title: "Primary Member",
        description: "Primary member can't be added as a secondary member",
        variant: "destructive",
      });
    }

    mutate(formData);

    // console.log(formData);
  }

  return (
    <div>
      <div className="flex flex-col items-center pb-10 ">
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className=" space-y-6">
            <p className="font-semibold">Enter Existing Member's Number</p>
            <FormField
              control={form.control}
              name="phone"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Phone</FormLabel>
                  <FormControl>
                    <PhoneInput {...field} className="" />
                  </FormControl>
                  <FormDescription>
                    Enter a valid phone number with country
                  </FormDescription>
                  <FormMessage />
                </FormItem>
              )}
            />
            <div className="space-y-3">
              <CustomButton
                type="submit"
                className="rounded-lg mt-6"
                btnName="Get OTP"
              />
            </div>
          </form>
        </Form>
      </div>
    </div>
  );
};

export default OTPVerification;
